import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SubmoduleCardComponent } from './submodule-card.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [SubmoduleCardComponent],
    declarations: [SubmoduleCardComponent],
})
export class SubmoduleCardModule { }
